import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import { isMobile } from 'react-device-detect';
import { isConfigFlagEnabled } from '../config';
import { addMessageBox } from '../redux/actions/messageBoxesActions';
import { useAppDispatch } from '../redux/store';
export const GoToPathButtonContainer = ({ isSuperAdminSection, closeDrawer }) => {
    const dispatch = useAppDispatch();
    if (!isMobile) {
        return null;
    }
    const isAvailable = isConfigFlagEnabled('goToPathAvailableForAllUsers') ? !isSuperAdminSection : isSuperAdminSection;
    if (!isAvailable) {
        return null;
    }
    return (_jsx(Button, { onClick: () => {
            dispatch(addMessageBox({ type: 'go-to-path' }));
            closeDrawer();
        }, variant: 'outlined', size: 'small', children: "Go To Path" }));
};
